import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../styles/hero.css';




gsap.registerPlugin(ScrollTrigger);

const Hero = () => {
  const wrapperRef = useRef(null);
  const frontRef = useRef(null);
  const nameScrollRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: wrapperRef.current,
          start: 'top top',
          end: '+=100%',
          scrub: true,
          pin: true,
        },
      });

      tl.to(frontRef.current, {
        scale: 0.8,
        ease: 'power3.out',
      }, 0);

      tl.to(nameScrollRef.current, {
        y: '-64%',
        ease: 'power3.out',
      }, 0);
    }, wrapperRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="hero-wrapper" ref={wrapperRef}>
      {/* BACK DIV */}
      <div className="back-div">
        <div className="scm-column left">
          <div className="tilt-wrapper scroll-up">
            <div className="tilted-scroll scroll-up">
              {'MCSTNEMERUCORP'.repeat(10).split('').map((char, i) => (
                <p className="left-tilt" key={`left-${i}`}>{char}</p>
              ))}
            </div>
          </div>
        </div>

        <div className="scm-column right">
          <div className="tilt-wrapper">
            <div className="tilted-scroll scroll-up">
              {'MCSTNEMERUCORP'.repeat(10).split('').map((char, i) => (
                <p className="left-tilt" key={`right-${i}`}>{char}</p>
              ))}
            </div>
          </div>
        </div>

        {/* <h1 className="back-title">Kosal Kanakia</h1> */}
      </div>

  <div className="front-div" ref={frontRef}>

  {/* Top Message */}
  <div className="top-message">
    <p>Your Journey Starts Below</p>
     <div className="down-arrow">v</div>
     <div className="down-secondarrow">v</div>
  </div>

  {/* Scrolling Name */}
  <div className="name-scroll-wrapper">
    <div className="name-scroll" ref={nameScrollRef}>
      <span className="first-name">Hi I'm</span>
      <span className="last-name">Kosal</span>
      <span className="Dot">Kanakia</span>
    </div>
  </div>

  {/* Bottom Tagline */}
  <div className="para">
    <p>Procurement · People · Investment · Society</p>
  </div>

</div>


    </section>
  );
};

export default Hero;
